<template>
    <a
        class="social"
        target="_blank"
        :class="classes"
        :href="link"
        :style="styles"
        @click="track"
    >
        <visual :svg="icon" />
        <paragraph size="M" v-if="label" :content="label" />
    </a>
</template>

<script>
import Paragraph from 'gvue/src/core/Paragraph'
import Visual from 'gvue/src/core/Visual'

import getImage from '@/helpers/image'

export default {
    name: 'IconSocial',
    components: {
        Paragraph,
        Visual
    },
    props: {
        color: { type: String, default: '#000000' },
        name: { type: String, required: true },
        label: { type: String },
        link: { type: String, required: true },
        size: { type: String, default: 'M' }
    },
    methods: {
        track() {
            const dataLayer = window.dataLayer ? window.dataLayer : []
            dataLayer.push({
                event: 'customEvent',
                eventCategory: 'User Engagement',
                eventAction: 'Click link',
                eventLabel: 'Connect Now - ' + this.name,
                nonInteraction: 0
            })
            /*
            event.preventDefault()
            window.open(this.link, '_blank')
            */
        }
    },
    computed: {
        icon() {
            return getImage({
                type: 'icon',
                name: `social_${this.name}`,
                landing: this.$landing
            })
        },
        classes() {
            return {
                XS: 'x-small',
                S: 'small',
                M: 'medium'
            }[this.size]
        },
        styles() {
            return {
                color: this.color
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.social
    display: flex
    align-items: center
    padding: 0 ($gap * 0.75)
    opacity: 0.625

::v-deep
    .g_visual
        display: block
        fill: currentColor
        width: auto
    [class*="g_txt"]
            font-weight: 500
            margin-left: ($gap * 0.625)

.x-small
    ::v-deep
        .g_visual
            height: pxToRem(16)
            width: pxToRem(16)

.small
    ::v-deep
        .g_visual
            height: pxToRem(22)
            width: pxToRem(22)

+desktop

    .social
        padding: 0 ($gap * 0.625)
        transform: opacity $easing $duration_fast

        &:hover
            opacity: 1

    .small
        ::v-deep .g_visual
            height: pxToRem(18)
            width: pxToRem(18)
</style>
